module.exports = __webpack_public_path__ + "static/SearchVideoEN-fddc3771a1bbd059414c0fbe3d8f3864.mp4";